import { render, staticRenderFns } from "./annotation-filter.vue?vue&type=template&id=49186d22"
import script from "./annotation-filter.vue?vue&type=script&lang=js"
export * from "./annotation-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports